module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalInforme
    }
  }), _c('div', {
    staticClass: "card card-padre",
    class: {
      'sidebar-open-card': _vm.showSidebarDesktop
    }
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_vm._m(0), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content position-relative"
  }, [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(1), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "hint--top inline",
      attrs: {
        "aria-label": 'log: ' + o.id
      }
    }, [_vm._v(_vm._s(o.descripcion || o.accion) + " ")]), _c('span', {
      staticClass: "hint--top has-text-bold",
      attrs: {
        "aria-label": o.fechaString
      }
    }, [_vm._v(_vm._s(_vm._f("fromNow")(o.fecha)))])]), _c('td', [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID relacionado: ' + o.idRelacionado
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(o.modulo)))])]), _c('td', [_c('div', [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Accion: ")]), _c('span', {
      staticClass: "hint--top tipo-icon",
      attrs: {
        "aria-label": o.tipo
      }
    }, [_c('i', {
      class: _vm.tipoIcon[o.tipo]
    })])]), _vm._l((o.datos), function(value, key) {
      return _c('div', [_c('span', {
        staticClass: "has-text-bold"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])
    })], 2)])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o) {
    return _c('div', {
      staticClass: "position-relative informe-contenedor"
    }, [_c('div', {
      staticClass: "fecha"
    }, [_c('span', [_vm._v(_vm._s(o.fechaString))])]), _c('div', {
      staticClass: "modulo"
    }, [_c('span', [_vm._v(_vm._s(o.modulo))])]), _c('div', {
      staticClass: "descripcion"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.descripcion))])]), _vm._l((o.datos), function(value, key) {
      return _c('div', {
        staticClass: "datos"
      }, [_c('div', [_c('span', {
        staticClass: "text-small"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(key)) + ": ")]), _c('span', [_vm._v(_vm._s(value))])])])
    }), _c('div', {
      staticClass: "solicitud"
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Solicitud: ")]), _c('span', [_vm._v(_vm._s(o.idRelacionado))])])], 2)
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "flex-1"
  }, [_c('span', [_vm._v("Informe de delegación")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Descripcion")]), _c('th', [_vm._v("Módulo")]), _c('th', [_vm._v("Datos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfbac6ea","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Delegaciones_Informe.vue
// module id = 886
// module chunks = 0